'use strict';

module.exports = require('./InputGroup');


//////////////////
// WEBPACK FOOTER
// ./~/bee-input-group/build/index.js
// module id = 592
// module chunks = 0